type Title = {
	uuid: string;
	label: string;
	value: string;
};

export const titles: Title[] = [
	{
		uuid: "9c970601-ae08-48f5-bfc2-1d8e053d110b",
		label: "Mr.",
		value: "Mr.",
	},
	{
		uuid: "9c970601-ae12-4294-bf59-38c0de11a914",
		label: "Mrs.",
		value: "Mrs.",
	},
	{
		uuid: "9c970601-ae15-4a59-afa1-dd01ba209b3d",
		label: "Ms.",
		value: "Ms.",
	},
	{
		uuid: "9c970601-ae17-43cf-8b9b-f9947263a9bc",
		label: "Dr.",
		value: "Dr.",
	},
	{
		uuid: "9c970601-ae18-4015-b577-9848b855a1b0",
		label: "Prof.",
		value: "Prof.",
	},
];
